
import { ActivityLimitDto, CreateActivityLimitDto, UpdateActivityLimitDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { activityLimitService, ActivityLimitsFilters } from '@services/ActivityLimitService'

const { reducer, actions, thunks } = baseCrudReducer<
  ActivityLimitDto,
  CreateActivityLimitDto,
  UpdateActivityLimitDto,
  ActivityLimitsFilters
>('activityLimit', activityLimitService)

export default reducer

export const { setFilters: setActivityLimitFilters } = actions

export const {
  getAll: getActivityLimits,
  create: createActivityLimit,
  update: updateActivityLimit,
  remove: removeActivityLimit,
} = thunks
